import React from "react";
import { useTranslation } from "react-i18next";
import Button from "components/Button";
import useAuthToken from "hooks/useAuthToken";
import { LogoRefabric } from "icons";
import { useNavigate } from "react-router-dom";
import { PATHS } from "router/config/paths";
import { getClearPath } from "utils";
import BillingRecoveryBanner from "components/BillingRecoveryBanner";

const NotAuthorized = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      {/* P7 Faz 1: when the paid access was lost to a failed payment, the remedy is paying — not a new plan. Outside the
          column below, so its gap does not push the actions down. */}
      <BillingRecoveryBanner />
      <div className="flex flex-col items-center h-screen w-screen gap-20 mt-10">
        <LogoRefabric />
        <div className="flex flex-col max-w-[520px] w-full">
          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-2.5">
              <h2 className="text-h2 text-center text-white">{t("common:not_authorized.title")}</h2>
              <span className="text-bodyMd text-grey text-center">{t("common:not_authorized.description")}</span>
            </div>
            <div className="flex gap-5">
              <Button
                className="btn-primary btn-sm w-full"
                onClick={() => {
                  useAuthToken.clearAuthTokenFromLocalStorage();
                  navigate(getClearPath(PATHS.LOGIN));
                }}
              >
                {t("common:not_authorized.go_to_login")}
              </Button>
              <Button
                className="btn-primary btn-sm w-full !bg-purple hover:!bg-pink"
                onClick={() => {
                  navigate("/pricing");
                }}
              >
                {t("common:not_authorized.go_to_pricing")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotAuthorized;
